module.exports = __webpack_public_path__ + "resources/img/logo_nhn_kcp_m.6189c6bcd15ecb3046b5c91b825322e7.png";